import { ColorSAP } from "../ontego-ui";

export const FUNCTION_TYPE = {
    MM: 'MM',
    SD: 'SD',
    PP: 'PP',
    WM: 'WM',
    EWM: 'EWM',
    QM: 'QM',
    PM: 'PM',
    EAM: 'EAM'
};
export const getFunctionTypeBackgroundColor = type => {
    switch (type) {
        case FUNCTION_TYPE.MM:
            return ColorSAP.primary[30];
        case FUNCTION_TYPE.SD:
            return ColorSAP.neutral[20];
        case FUNCTION_TYPE.PP:
            return ColorSAP.danger[20];
        case FUNCTION_TYPE.WM:
            return ColorSAP.secondary[20];
        case FUNCTION_TYPE.EWM:
            return ColorSAP.success[20];
        case FUNCTION_TYPE.QM:
            return ColorSAP.neutral[80];
        case FUNCTION_TYPE.PM:
            return ColorSAP.danger[50];
        case FUNCTION_TYPE.EAM:
            return ColorSAP.secondary[50];
        
        default:
            return null;
    }
};
export const getFunctionTypeLabelColor = type => {
    switch (type) {
        case FUNCTION_TYPE.MM:
            return ColorSAP.primary[80];
        case FUNCTION_TYPE.SD:
            return ColorSAP.neutral[90];
        case FUNCTION_TYPE.PP:
            return ColorSAP.danger[80];
        case FUNCTION_TYPE.WM:
            return ColorSAP.secondary[70];
        case FUNCTION_TYPE.EWM:
            return ColorSAP.success[80];
        case FUNCTION_TYPE.QM:
            return ColorSAP.neutral[0];
        case FUNCTION_TYPE.PM:
            return ColorSAP.neutral[0];
        case FUNCTION_TYPE.EAM:
            return ColorSAP.neutral[0];
        
        default:
            return null;
    }
};
